import { render, staticRenderFns } from "./dealBookName.vue?vue&type=template&id=a3e1c2e0&scoped=true&"
import script from "./dealBookName.vue?vue&type=script&lang=js&"
export * from "./dealBookName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e1c2e0",
  null
  
)

export default component.exports